// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Custom styles for react-calendar to match reference design with dark mode support */
.react-calendar {
  width: 100%;
  background: white;
  border: none;
  font-family: inherit;
  line-height: 1.125em;
}

.dark .react-calendar {
  background: #1f2937;
}

.react-calendar__navigation {
  display: flex;
  height: 44px;
  margin-bottom: 1em;
}

.react-calendar__navigation button {
  min-width: 44px;
  background: none;
  font-size: 16px;
  margin-top: 8px;
  color: #374151;
  font-weight: 500;
}

.dark .react-calendar__navigation button {
  color: #e5e7eb;
}

.react-calendar__navigation button:enabled:hover,
.react-calendar__navigation button:enabled:focus {
  background-color: #f3f4f6;
  border-radius: 6px;
}

.dark .react-calendar__navigation button:enabled:hover,
.dark .react-calendar__navigation button:enabled:focus {
  background-color: #374151;
}

.react-calendar__navigation button[disabled] {
  background-color: #f0f0f0;
  color: #9ca3af;
}

.dark .react-calendar__navigation button[disabled] {
  background-color: #374151;
  color: #6b7280;
}

.react-calendar__month-view__weekdays {
  text-align: center;
  text-transform: uppercase;
  font-weight: 600;
  font-size: 0.75em;
  color: #6b7280;
  padding-bottom: 0.5em;
}

.dark .react-calendar__month-view__weekdays {
  color: #9ca3af;
}

.react-calendar__month-view__weekdays__weekday {
  padding: 0.5em;
}

.react-calendar__month-view__weekdays__weekday abbr {
  text-decoration: none;
}

.react-calendar__month-view__days {
  display: grid !important;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
}

.react-calendar__tile {
  max-width: 100%;
  padding: 0.75em 0.5em;
  background: none;
  text-align: center;
  line-height: 16px;
  font-size: 0.833em;
  color: #374151;
  border-radius: 6px;
  transition: background-color 0.15s, color 0.15s, box-shadow 0.15s;
  outline: none;
  border: 2px solid transparent;
  cursor: pointer;
}

.dark .react-calendar__tile {
  color: #e5e7eb;
}

.react-calendar__tile:enabled:hover,
.react-calendar__tile:enabled:focus {
  background-color: var(--theme-accent-light, #e0e7ff);
  color: var(--theme-primary, #4f46e5);
  border-radius: 6px;
  outline: none;
  box-shadow: none;
}

.dark .react-calendar__tile:enabled:hover,
.dark .react-calendar__tile:enabled:focus {
  background-color: rgba(99, 102, 241, 0.15);
  color: #a5b4fc;
  outline: none;
  box-shadow: none;
}

.react-calendar__tile--now {
  background: #fef3c7;
  color: #92400e;
  font-weight: 600;
  border: 1px solid #fbbf24;
}

.dark .react-calendar__tile--now {
  background: rgba(251, 191, 36, 0.2);
  color: #fbbf24;
  border-color: rgba(251, 191, 36, 0.5);
}

.react-calendar__tile--now:enabled:hover,
.react-calendar__tile--now:enabled:focus {
  background: #fde68a;
}

.dark .react-calendar__tile--now:enabled:hover,
.dark .react-calendar__tile--now:enabled:focus {
  background: rgba(251, 191, 36, 0.3);
}

/* When today is also selected, prioritize selected styling */
.react-calendar__tile--now.react-calendar__tile--active {
  background: var(--theme-primary, #6366f1) !important;
  color: white !important;
  border: 2px solid var(--theme-primary, #4f46e5) !important;
  box-shadow: var(--theme-button-shadow, 0 2px 4px rgba(99, 102, 241, 0.4));
}

.react-calendar__tile--hasActive {
  background: var(--theme-primary, #4f46e5);
  color: white;
}

.react-calendar__tile--hasActive:enabled:hover,
.react-calendar__tile--hasActive:enabled:focus {
  background: var(--theme-primary-dark, #4338ca);
}

.react-calendar__tile--active {
  background: var(--theme-primary, #6366f1) !important;
  color: white !important;
  font-weight: 600;
  border: 2px solid var(--theme-primary, #4f46e5);
  box-shadow: 0 2px 4px rgba(99, 102, 241, 0.4);
}

.react-calendar__tile--active:enabled:hover,
.react-calendar__tile--active:enabled:focus {
  background: var(--theme-primary-dark, #4f46e5) !important;
  color: white !important;
  outline: none;
  box-shadow: 0 2px 6px rgba(99, 102, 241, 0.5);
}

.dark .react-calendar__tile--active:enabled:hover,
.dark .react-calendar__tile--active:enabled:focus {
  background: var(--theme-primary-dark, #4f46e5) !important;
  color: white !important;
  outline: none;
  box-shadow: 0 2px 6px rgba(99, 102, 241, 0.4);
}

/* Neighboring month tiles */
.react-calendar__month-view__days__day--neighboringMonth {
  color: #d1d5db;
}

.dark .react-calendar__month-view__days__day--neighboringMonth {
  color: #4b5563;
}

/* Weekend styling */
.react-calendar__month-view__days__day--weekend {
  color: #dc2626;
}

.dark .react-calendar__month-view__days__day--weekend {
  color: #f87171;
}

/* Disabled / past date tiles */
.react-calendar__tile:disabled {
  background-color: transparent;
  color: #d1d5db;
  cursor: not-allowed;
  opacity: 0.5;
}

.dark .react-calendar__tile:disabled {
  background-color: transparent;
  color: #4b5563;
  opacity: 0.4;
}

/* Weekend days that are disabled (past) */
.dark .react-calendar__month-view__days__day--weekend:disabled {
  color: #6b4444;
  opacity: 0.4;
}

/* Locked dates from previous sessions */
.react-calendar__tile--locked {
  background-color: #e5e7eb !important;
  color: #6b7280 !important;
  font-weight: 500;
  border: 2px solid #9ca3af !important;
}

.dark .react-calendar__tile--locked {
  background-color: #374151 !important;
  color: #9ca3af !important;
  border-color: #6b7280 !important;
}

/* Dates with existing global slots (from other searches) */
.react-calendar__tile--has-global-slots {
  background-color: #fef3c7 !important;
  color: #92400e !important;
  font-weight: 500;
  border: 2px dashed #f59e0b !important;
  position: relative;
}

.dark .react-calendar__tile--has-global-slots {
  background-color: rgba(245, 158, 11, 0.15) !important;
  color: #fbbf24 !important;
  border-color: rgba(245, 158, 11, 0.5) !important;
}

.react-calendar__tile--has-global-slots:enabled:hover {
  background-color: #fde68a !important;
}

.dark .react-calendar__tile--has-global-slots:enabled:hover {
  background-color: rgba(245, 158, 11, 0.25) !important;
}

/* When a date with global slots is also selected, prioritize selected styling */
.react-calendar__tile--has-global-slots.react-calendar__tile--active {
  background: var(--theme-primary, #6366f1) !important;
  color: white !important;
  border: 2px solid var(--theme-primary, #4f46e5) !important;
}

/* Scrollbar styling for modal content */
.interview-scheduler-content::-webkit-scrollbar {
  width: 6px;
}

.interview-scheduler-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.dark .interview-scheduler-content::-webkit-scrollbar-track {
  background: #374151;
}

.interview-scheduler-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.dark .interview-scheduler-content::-webkit-scrollbar-thumb {
  background: #6b7280;
}

.interview-scheduler-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.dark .interview-scheduler-content::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}
`, "",{"version":3,"sources":["webpack://./src/components/InterviewScheduler/InterviewScheduler.css"],"names":[],"mappings":"AAAA,sFAAsF;AACtF;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,iEAAiE;EACjE,aAAa;EACb,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,oDAAoD;EACpD,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,0CAA0C;EAC1C,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,qCAAqC;AACvC;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA,6DAA6D;AAC7D;EACE,oDAAoD;EACpD,uBAAuB;EACvB,0DAA0D;EAC1D,yEAAyE;AAC3E;;AAEA;EACE,yCAAyC;EACzC,YAAY;AACd;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA;EACE,oDAAoD;EACpD,uBAAuB;EACvB,gBAAgB;EAChB,+CAA+C;EAC/C,6CAA6C;AAC/C;;AAEA;;EAEE,yDAAyD;EACzD,uBAAuB;EACvB,aAAa;EACb,6CAA6C;AAC/C;;AAEA;;EAEE,yDAAyD;EACzD,uBAAuB;EACvB,aAAa;EACb,6CAA6C;AAC/C;;AAEA,4BAA4B;AAC5B;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,6BAA6B;EAC7B,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,YAAY;AACd;;AAEA,0CAA0C;AAC1C;EACE,cAAc;EACd,YAAY;AACd;;AAEA,wCAAwC;AACxC;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,2DAA2D;AAC3D;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;EACrD,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qDAAqD;AACvD;;AAEA,gFAAgF;AAChF;EACE,oDAAoD;EACpD,uBAAuB;EACvB,0DAA0D;AAC5D;;AAEA,wCAAwC;AACxC;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* Custom styles for react-calendar to match reference design with dark mode support */\n.react-calendar {\n  width: 100%;\n  background: white;\n  border: none;\n  font-family: inherit;\n  line-height: 1.125em;\n}\n\n.dark .react-calendar {\n  background: #1f2937;\n}\n\n.react-calendar__navigation {\n  display: flex;\n  height: 44px;\n  margin-bottom: 1em;\n}\n\n.react-calendar__navigation button {\n  min-width: 44px;\n  background: none;\n  font-size: 16px;\n  margin-top: 8px;\n  color: #374151;\n  font-weight: 500;\n}\n\n.dark .react-calendar__navigation button {\n  color: #e5e7eb;\n}\n\n.react-calendar__navigation button:enabled:hover,\n.react-calendar__navigation button:enabled:focus {\n  background-color: #f3f4f6;\n  border-radius: 6px;\n}\n\n.dark .react-calendar__navigation button:enabled:hover,\n.dark .react-calendar__navigation button:enabled:focus {\n  background-color: #374151;\n}\n\n.react-calendar__navigation button[disabled] {\n  background-color: #f0f0f0;\n  color: #9ca3af;\n}\n\n.dark .react-calendar__navigation button[disabled] {\n  background-color: #374151;\n  color: #6b7280;\n}\n\n.react-calendar__month-view__weekdays {\n  text-align: center;\n  text-transform: uppercase;\n  font-weight: 600;\n  font-size: 0.75em;\n  color: #6b7280;\n  padding-bottom: 0.5em;\n}\n\n.dark .react-calendar__month-view__weekdays {\n  color: #9ca3af;\n}\n\n.react-calendar__month-view__weekdays__weekday {\n  padding: 0.5em;\n}\n\n.react-calendar__month-view__weekdays__weekday abbr {\n  text-decoration: none;\n}\n\n.react-calendar__month-view__days {\n  display: grid !important;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 2px;\n}\n\n.react-calendar__tile {\n  max-width: 100%;\n  padding: 0.75em 0.5em;\n  background: none;\n  text-align: center;\n  line-height: 16px;\n  font-size: 0.833em;\n  color: #374151;\n  border-radius: 6px;\n  transition: background-color 0.15s, color 0.15s, box-shadow 0.15s;\n  outline: none;\n  border: 2px solid transparent;\n  cursor: pointer;\n}\n\n.dark .react-calendar__tile {\n  color: #e5e7eb;\n}\n\n.react-calendar__tile:enabled:hover,\n.react-calendar__tile:enabled:focus {\n  background-color: var(--theme-accent-light, #e0e7ff);\n  color: var(--theme-primary, #4f46e5);\n  border-radius: 6px;\n  outline: none;\n  box-shadow: none;\n}\n\n.dark .react-calendar__tile:enabled:hover,\n.dark .react-calendar__tile:enabled:focus {\n  background-color: rgba(99, 102, 241, 0.15);\n  color: #a5b4fc;\n  outline: none;\n  box-shadow: none;\n}\n\n.react-calendar__tile--now {\n  background: #fef3c7;\n  color: #92400e;\n  font-weight: 600;\n  border: 1px solid #fbbf24;\n}\n\n.dark .react-calendar__tile--now {\n  background: rgba(251, 191, 36, 0.2);\n  color: #fbbf24;\n  border-color: rgba(251, 191, 36, 0.5);\n}\n\n.react-calendar__tile--now:enabled:hover,\n.react-calendar__tile--now:enabled:focus {\n  background: #fde68a;\n}\n\n.dark .react-calendar__tile--now:enabled:hover,\n.dark .react-calendar__tile--now:enabled:focus {\n  background: rgba(251, 191, 36, 0.3);\n}\n\n/* When today is also selected, prioritize selected styling */\n.react-calendar__tile--now.react-calendar__tile--active {\n  background: var(--theme-primary, #6366f1) !important;\n  color: white !important;\n  border: 2px solid var(--theme-primary, #4f46e5) !important;\n  box-shadow: var(--theme-button-shadow, 0 2px 4px rgba(99, 102, 241, 0.4));\n}\n\n.react-calendar__tile--hasActive {\n  background: var(--theme-primary, #4f46e5);\n  color: white;\n}\n\n.react-calendar__tile--hasActive:enabled:hover,\n.react-calendar__tile--hasActive:enabled:focus {\n  background: var(--theme-primary-dark, #4338ca);\n}\n\n.react-calendar__tile--active {\n  background: var(--theme-primary, #6366f1) !important;\n  color: white !important;\n  font-weight: 600;\n  border: 2px solid var(--theme-primary, #4f46e5);\n  box-shadow: 0 2px 4px rgba(99, 102, 241, 0.4);\n}\n\n.react-calendar__tile--active:enabled:hover,\n.react-calendar__tile--active:enabled:focus {\n  background: var(--theme-primary-dark, #4f46e5) !important;\n  color: white !important;\n  outline: none;\n  box-shadow: 0 2px 6px rgba(99, 102, 241, 0.5);\n}\n\n.dark .react-calendar__tile--active:enabled:hover,\n.dark .react-calendar__tile--active:enabled:focus {\n  background: var(--theme-primary-dark, #4f46e5) !important;\n  color: white !important;\n  outline: none;\n  box-shadow: 0 2px 6px rgba(99, 102, 241, 0.4);\n}\n\n/* Neighboring month tiles */\n.react-calendar__month-view__days__day--neighboringMonth {\n  color: #d1d5db;\n}\n\n.dark .react-calendar__month-view__days__day--neighboringMonth {\n  color: #4b5563;\n}\n\n/* Weekend styling */\n.react-calendar__month-view__days__day--weekend {\n  color: #dc2626;\n}\n\n.dark .react-calendar__month-view__days__day--weekend {\n  color: #f87171;\n}\n\n/* Disabled / past date tiles */\n.react-calendar__tile:disabled {\n  background-color: transparent;\n  color: #d1d5db;\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.dark .react-calendar__tile:disabled {\n  background-color: transparent;\n  color: #4b5563;\n  opacity: 0.4;\n}\n\n/* Weekend days that are disabled (past) */\n.dark .react-calendar__month-view__days__day--weekend:disabled {\n  color: #6b4444;\n  opacity: 0.4;\n}\n\n/* Locked dates from previous sessions */\n.react-calendar__tile--locked {\n  background-color: #e5e7eb !important;\n  color: #6b7280 !important;\n  font-weight: 500;\n  border: 2px solid #9ca3af !important;\n}\n\n.dark .react-calendar__tile--locked {\n  background-color: #374151 !important;\n  color: #9ca3af !important;\n  border-color: #6b7280 !important;\n}\n\n/* Dates with existing global slots (from other searches) */\n.react-calendar__tile--has-global-slots {\n  background-color: #fef3c7 !important;\n  color: #92400e !important;\n  font-weight: 500;\n  border: 2px dashed #f59e0b !important;\n  position: relative;\n}\n\n.dark .react-calendar__tile--has-global-slots {\n  background-color: rgba(245, 158, 11, 0.15) !important;\n  color: #fbbf24 !important;\n  border-color: rgba(245, 158, 11, 0.5) !important;\n}\n\n.react-calendar__tile--has-global-slots:enabled:hover {\n  background-color: #fde68a !important;\n}\n\n.dark .react-calendar__tile--has-global-slots:enabled:hover {\n  background-color: rgba(245, 158, 11, 0.25) !important;\n}\n\n/* When a date with global slots is also selected, prioritize selected styling */\n.react-calendar__tile--has-global-slots.react-calendar__tile--active {\n  background: var(--theme-primary, #6366f1) !important;\n  color: white !important;\n  border: 2px solid var(--theme-primary, #4f46e5) !important;\n}\n\n/* Scrollbar styling for modal content */\n.interview-scheduler-content::-webkit-scrollbar {\n  width: 6px;\n}\n\n.interview-scheduler-content::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 3px;\n}\n\n.dark .interview-scheduler-content::-webkit-scrollbar-track {\n  background: #374151;\n}\n\n.interview-scheduler-content::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 3px;\n}\n\n.dark .interview-scheduler-content::-webkit-scrollbar-thumb {\n  background: #6b7280;\n}\n\n.interview-scheduler-content::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n.dark .interview-scheduler-content::-webkit-scrollbar-thumb:hover {\n  background: #9ca3af;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
